import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray, white, black, red, lightergray } from '../../styles/colors'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  ${maxmedia.large`
    position: absolute;
    background: ${lightergray};
  `}

  ${minmedia.large`
    position: fixed;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
        z-index: 10;
  `}
`

export const Popup = styled.div`
  position: relative;

  ${maxmedia.large`
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  `}
  ${minmedia.large`
    overflow: hidden;
    width: 97%;
    max-width: 700px;
    border-radius: 0.25rem;
    background: ${white};
    border: 1px solid ${bordergray};
    box-shadow: 0px 1px 8px 3px rgba(0, 0, 0, 0.2);
  `}
`

export const Inner = styled.div`
  width: 100%;
  padding: 1rem 1.5rem;

  ${minmedia.large`
    padding: 2rem;
  `}
`

export const Header = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${minmedia.large`
    padding-bottom: 1.5rem;
  `}
`

export const Title = styled.p`
  text-align: center;
  margin: 0;
  flex: 1;
`

export const CloseButton = styled.div`
  cursor: pointer;
  width: 2rem;
  text-align: right;
  margin-top: .3rem;

  &:hover {
    fill: ${red};
  }

  svg {
    width: .75rem;
    height: .75rem;
    fill: ${black};
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  text-align: center;

  div {
    font-size: 16px;
  }

  ${maxmedia.medium`
    div {
      display: block;
      margin: 0 auto;
      width: 270px;
      max-width: 100%;
      text-align: center;
    }
    button {
      font-size: 16px;
      &:first-child {
        margin-bottom: 0.5rem;
      }
    }

    div:first-child {
      margin-bottom: .5rem;
    }
  `}
  ${minmedia.medium`
    div:first-child {
      margin-right: 1rem;
    }
  `}

  @media screen and (max-width: 374px) {
    div {
      font-size: 14px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/DeletePopup/styles.js